let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cwkUf")).then(() => parcelRequire('j8IiS'));